import mitt from "mitt";
import { PopupBusEvents } from "./types";
export const bus = mitt<PopupBusEvents>();
